import moment from "moment";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const noimage = require("@/assets/images/muuq-base/noimage.png");

// const mappingCodePricing = {
//   "10": "maker_price",
//   "11": "shop_price",
//   "12": "user_price",
//   "13": "industry4_price",
//   "14": "industry5_price",
//   "15": "industry6_price",
//   "16": "industry7_price",
//   "17": "industry8_price",
//   "18": "industry9_price",
//   "19": "industry10_price",
// };

// const mappingCodeSalePricing = {
//   "10": "set_maker_price",
//   "11": "set_shop_price",
//   "12": "set_user_price",
//   "13": "set_price4",
//   "14": "set_price5",
//   "15": "set_price6",
//   "16": "set_price7",
//   "17": "set_price8",
//   "18": "set_price9",
//   "19": "set_price10",
// };

export const PRODUCT_STATUS = {
  active: 1,
  inActive: 0,
};

export interface IProduct {
  item_code?: string;
  cart_item_discription: string;
  cart_item_image: string;
  created_at: string;
  master_product: MasterProduct;
  customer_price: CustomerPrice;
  cart_cate_code: string;
  status: number;
  order: number;
}

export class ProductDTO implements IProduct {
  item_code?: string;
  cart_item_discription: string;
  cart_item_image: string;
  m_cart_image: Image;
  created_at: string;
  master_product: MasterProduct;
  customer_price: CustomerPrice;
  cart_cate_code: string;
  status: number;
  order: number;
  price: number;

  cart_quanlity?: number = null;
}

export class MasterProduct {
  item_code: string;
  prvnc: string;
  item_name_1: string;
  item_name_2: string;
  unit: string;
  expire_date: string;
  maker_price: number;
  shop_price: number;
  user_price: number;
  max_orre_quantity: number;
  size_3M: string;
  weight: string;
  postage_identification_kbn: number;
  product_weight_g: number;
  sales_judge_kbn: number;
  constructor(dto) {
    Object.assign(this, dto);
  }

  get productWeightName() {
    return this.product_weight_g ? window.Number.parseFloat(this.product_weight_g.toString()).toFixed(2) : 0;
  }
}

export class CustomerPrice {
  item_code: string;
  customer_price: string;
  constructor(dto) {
    Object.assign(this, dto);
  }
}

export class Category {
  category_name: string;
  category_code: string;
  category_sort: number;

  constructor(dto) {
    Object.assign(this, dto);
  }
}

export class SaleBoom {
  set_item_code: string;
  item_code: string;
  quantity_per_carton: number;
  set_item_name_1: string;
  set_item_name_2: string;
  set_unit: string;
  set_maker_price: number;
  set_shop_price: number;
  set_user_price: number;
  delete_kbn: string;
  auto_kbn: string;
  set_price4: number;
  set_price5: number;
  set_price6: number;
  set_price7: number;
  set_price8: number;
  set_price9: number;
  set_price10: number;
  max_orre_quantity: number;
  size_3M: string;
  weight: number;
  product_weight_g: number;
  free_postage_kbn: number;
  unit: number;
  user_price: number;
  price: number;

  cart_quanlity?: number = null;
  sellingCode = null;
  product?: Product = null;
  mnfct_num = null;
  order_num = null;
  cart_orre_ctrl_num = null;
  uuid: string;

  constructor(dto) {
    Object.assign(this, dto);
    this.product = dto.product ? new Product(dto.product) : null;
  }

  get unitName() {
    return `${this.set_unit.trim().length > 0 ? '1' + this.set_unit : '' }（${this.quantity_per_carton + this.unit}入り）`;
  }

  get maxQuanitty() {
    return Intl.NumberFormat().format(this.max_orre_quantity);
  }
  get userPrice() {      
    if (this.auto_kbn == "1") {
      return this.quantity_per_carton * this.user_price;
    }

    return Intl.NumberFormat().format(this.set_user_price);
  }

  get free() {
    return this.free_postage_kbn == 1 ? "free" : "";
  }

  get weightName() {
    const ProductWeightG = this.product_weight_g ? window.Number.parseFloat(this.product_weight_g.toString()) : 0;
    
    const sum = ProductWeightG * this.quantity_per_carton;
    return (sum ? sum.toFixed(2) : 0) + "g";
  }

  get total() {
    return this.cart_quanlity * this.price;
  }

  get piKbn() {
    if (!this.product) return "";
    return this.product.master_product.postage_identification_kbn;
  }

  public setCustomerPrice(sellingCode) {
    this.sellingCode = sellingCode;
  }
}

import { DATE_TIME_FORMAT } from "@/common/constant";
import Image from "./image";
import _ from "lodash";

export default class Product extends ProductDTO {
  createdDateTime;
  category;
  sellingCode = null;
  mnfct_num = null;
  order_num = null;
  cart_orre_ctrl_num = null;
  is_changed = false;
  uuid: string;
  set_item_code = null;
  
  constructor(dto?: ProductDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      this.createdDateTime = moment(this.created_at);
      this.master_product = this.master_product
        ? new MasterProduct(this.master_product)
        : null;
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      item_code: null,
      cart_item_discription: "",
      cart_item_image: null,
      cart_cate_code: null,
      master_product: null,
      m_cart_image: null,
      status: 0,
    });
  }

  get createdAt(): string {
    return this.createdDateTime.format(DATE_TIME_FORMAT);
  }

  get itemName() {
    if (!this.master_product) return "";
    return this.master_product.item_name_1 + this.master_product.item_name_2;
  }

  get userPrice() {
    if (!this.master_product) return "";
    return Intl.NumberFormat().format(this.master_product.user_price);
  }

  get unitName() {
    if (!this.master_product) return "";
    return (
      this.master_product.max_orre_quantity.toString() +
      this.master_product.unit
    );
  }
  get size() {
    if (!this.master_product) return "";
    return this.master_product.size_3M;
  }

  get weight() {
    if (!this.master_product) return "";
    
    if (!Number(this.master_product.product_weight_g)) {
      return 0;
    }

    return window.Number.parseFloat(this.master_product.product_weight_g.toString()).toFixed(2);
  }

  get thumbnailUrl() {
    if (!this.m_cart_image) return noimage;
    return this.m_cart_image.thumbnail_url;
  }

  get imageUrl() {
    if (!this.m_cart_image) return noimage;
    return this.m_cart_image.original_url;
  }

  get cateName() {
    if (!this.category) return "";
    return this.category.category_name;
  }

  get piKbn() {
    if (!this.master_product) return "";
    return this.master_product.postage_identification_kbn;
  }

  get total() {
    return this.cart_quanlity * this.price;
  }

  get saleStatus() {
    const offElements = _.find([3,7,8,9], (item) => {
      return this.master_product?.sales_judge_kbn == item;
    });

    if (!this.status) {
      return "off";
    }
    
    return offElements > 0 ? "off" : "";
  }

  public setCustomerPrice(sellingCode) {
    this.sellingCode = sellingCode;
  }

  get canOrder() {
    return this.status === 1;
  }
}
